import { render, staticRenderFns } from "./CompactCheckoutDetails.vue?vue&type=template&id=3167a7c3&scoped=true"
import script from "./CompactCheckoutDetails.vue?vue&type=script&lang=js"
export * from "./CompactCheckoutDetails.vue?vue&type=script&lang=js"
import style0 from "./CompactCheckoutDetails.vue?vue&type=style&index=0&id=3167a7c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3167a7c3",
  null
  
)

export default component.exports